@if (isBannerVisible) {
  <sd-info-banner
    [brand]="brand"
    [isVisible]="isBannerVisible"
    textKey="product.brandcorner.banner.text"
    [data]="bannerData"
    (isVisibleChange)="bannerVisibilityChange()"
  />
}

@if (isLoading || overview) {
  <sd-product-overview
    [isSSR]="isSSR"
    [showSkeeper]="showSkeeper"
    [objSkeeper]="objSkeeper"
    [overview]="overview"
    [madeInData]="madeInData"
    [isLoading]="isLoading"
    [iAdvizeEnabled]="iAdvizeEnabled"
    [images]="images"
    [quantityDisabled]="quantityDisabled"
    [titleLevel]="1"
    [klarnaData]="klarnaData"
    [refurbishedData]="refurbishedData"
    (changeStore)="isStoreModalOpened = true"
    (cart)="addToCart($event)"
    (notify)="notifyMe()"
    (compatibilityCheck)="isCompatibleClicked()"
    (productSellerModal)="openSellerModal()"
    (dividedClick)="dividedClick()"
    (repairabilityInfoClick)="onRepairabilityInfoClick()"
    (repairabilityLinkClick)="onRepairabilityLinkClick()"
    (openRecommendedPriceModal)="openRecommendedPriceModal()"
    (productFeatureClick)="onProductFeatureClick()"
    (reinsurancesPdpClick)="onReinsurancesPdpClick($event)"
    [brand]="brand"
    [isForfait]="isForfait"
    [isOpenRef]="isOpenRef"
    pageTemplate="Product"
  >
    @if (displayPayPalBanner) {
      <wc-paypal-banner
        [price]="price"
        [position]="POSITION"
        [messageLanguage]="activeLanguage"
        sd-additional-elements
      />
    }
    @if (hasVideos) {
      <wc-skeeper-shoppable-content
        sd-shoppable-content
        [data]="skeeperShoppableContentData"
        (hasVideos)="checkHasVideos($event)"
      />
    }
    <div sections>
      <ng-content select="[pdp-sections]" />
    </div>
  </sd-product-overview>
}

@if (product) {
  @defer (when isStoreModalOpened) {
    <sd-modal-default
      [(isOpened)]="isStoreModalOpened"
      [modalTitle]="'storelocator.changeStoreModalTitle' | translate"
      [modalTitleLevel]="4"
      [noPadding]="true"
    >
      @if (isStoreModalOpened) {
        <wc-store-locator />
      }
    </sd-modal-default>
  }

  <sd-product-seller-modal
    [(isOpened)]="isOpenedSellerModal"
  />

  <wc-product-notification-modal
    [productCode]="product.code"
    [productName]="product.name"
    [(notifyModalOpened)]="notifyModalOpened"
  />

  <wc-oney-modal
    [(isOpenedOneyModal)]="isOpenedOneyModal"
    [productCode]="product.code"
  />

  <wc-omnibus-recommended-price-modal
    [(isOpenedRecommendedPriceModal)]="isOpenedRecommendedModal"
  />
}
